var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-wrapper", style: "width:" + _vm.widthInput },
    [
      _c("div", { staticClass: "input-container mb-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pesquisaSimples,
              expression: "pesquisaSimples"
            }
          ],
          attrs: {
            type: "text",
            placeholder: _vm.placeholder,
            id: "filtroSimples"
          },
          domProps: { value: _vm.pesquisaSimples },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.pesquisar($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.pesquisaSimples = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "search-icon", on: { click: _vm.pesquisar } },
          [_c("i", { staticClass: "el-icon-search font-wt-4" })]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-bottom gap-3" },
        [
          _vm._t("filtros"),
          _vm._v(" "),
          _c("CustomButton", {
            attrs: { type: "OutlinedButton", text: "Filtrar" },
            on: { click: _vm.pesquisar }
          }),
          _vm._v(" "),
          _c("CustomButton", {
            attrs: { type: "IconButton", text: "Limpar" },
            on: { click: _vm.limpar }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09527ae6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09527ae6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue
// module id = null
// module chunks = 